import React from 'react'
import { Button, notification } from 'antd'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'

import { ItemList } from '~components'
import { getCurrentUser } from '~context'
import { PageLayout } from '~stories'

import './VLPCards.modules.css'

const PAGE_TITLE = 'VLP Cards'
const NOTIFICATION_MESSAGES = {
  UNAUTHORIZED: 'You are not authorized to perform this action.'
}

const getVenueNameWithLink = (vlpCard) => <a href={`/venues/venue-landing-cards/${vlpCard._id}/edit`}>{String(vlpCard.name).toUpperCase()}</a>

const columnData = [
  {
    dataIndex: 'name',
    render: (text, vlpCard) => getVenueNameWithLink(vlpCard),
    sorter: true,
    title: 'Name',
    width: '30%'
  },
  {
    dataIndex: 'venue',
    title: 'Venue',
    width: '30%'
  }
]

const addNewVenue = isContentEditor => {
  return (
    <Route render={({ history }) => (
      <Button
        key="1"
        onClick={() => {
          isContentEditor
            ? history.push('/venues/venue-landing-cards/new')
            : notification.error({ message: NOTIFICATION_MESSAGES.UNAUTHORIZED })
        }}
        type="primary"
      >
        Add Custom Card
      </Button>
    )} />
  )
}

const VLPCards = () => {
  const { userDetails: { isContentEditor } } = getCurrentUser()

  return (
    <PageLayout extra={[addNewVenue(isContentEditor)]} title={PAGE_TITLE}
    >
      <div className="venues-layout-background">
        <ItemList columns={columnData} resource='vlpCards' />
      </div>
    </PageLayout>
  )
}

VLPCards.propTypes = {
  allVenues: PropTypes.array,
  message: PropTypes.string,
  status: PropTypes.bool,
  triggerAdhocTMImport: PropTypes.func.isRequired
}

export default VLPCards
